@let ast = asset();

@switch (mode()) {
  @case ('thumbnail') {
<!--    <i class="fa fa-file"></i>-->
    <img [ngSrc]="ast.url" width="24" height="24" [alt]="ast.displayName" class="img-fluid w-100" />
  }
  @case ('view') {
    <img [src]="ast.url" [alt]="ast.displayName" class="img-fluid w-100" />
  }
  @case ('details') {
    <img [src]="ast.url" [alt]="ast.displayName" class="img-fluid w-100" />
    <dl>
      <div class="row">
        <dt>URL:</dt>
        <dd><a [href]="ast.url" target="_blank">{{ ast.url }}</a></dd>
      </div>
      @if (ast.mimeType) {
        <div class="row">
          <dt>MIME:</dt>
          <dd>{{ ast.mimeType }}</dd>
        </div>
      }
      <div class="row">
        <dt>Description:</dt>
        <dd>{{ ast.description }}</dd>
      </div>
    </dl>
  }
}
